// reducers/systems/inputs.js

export function inputsHasErrored(state = false, action) {
  switch (action.type) {
    case 'INPUTS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function inputsIsLoading(state = false, action) {
  switch (action.type) {
    case 'INPUTS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function inputs(state = [], action) {
  switch (action.type) {
    case 'INPUTS_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}